(function() {
    'use strict';

    angular
        .module('liverunApp')
        .controller('MedalBoardController', MedalBoardController);

    MedalBoardController.$inject = ['MedalBoard'];

    function MedalBoardController(MedalBoard) {

        var vm = this;

        vm.medalBoards = [];

        loadAll();

        function loadAll() {
            MedalBoard.query(function(result) {
                vm.medalBoards = result;
                vm.searchQuery = null;
            });
        }
    }
})();
